import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reparacion',
  templateUrl: './reparacion.component.html',
  styleUrls: ['./reparacion.component.css']
})
export class ReparacionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
